import { cloneDeep, set } from "lodash-es"
import { action, makeObservable, observable } from "mobx"

import {
  LanguageModule,
  OriginData,
} from "@/api/returnpage/type/returnPageConfig"

export type langInfo = {
  code: string
  ename: string
  is_default: 0 | 1
  name: string
  is_publish: 1 | 2
}

class LanguageStore {
  // 用于撤回用的原来的字段 字段就这样没办法
  @observable public originData: OriginData = {
    check_page: {
      discount: "",
      refund: "",
      return_fee: "",
      shipping_fee: "",
      subtotal: "",
      tax: "",
      title: "",
      total_refund: "",
    },
    login_page: {
      bottom_description: "",
      confirm_button_name: "",
      email_address: "",
      error_tips_1: "",
      error_tips_2: "",
      error_tips_3: "",
      order_bottom_description: "",
      order_confirm_button_name: "",
      order_email_address: "",
      order_number: "",
      policy_popup_name: "",
      policy_text: "",
      return_center: "",
      verification_code: "",
    },
    order_list_details_page: {
      create_return_button: "",
      items: "",
      log_out_button: "",
      missed_the_return_window: "",
      non_returnable_items: "",
      non_returnable_reason: "",
      order_has_been_refunded_at_shopify: "",
      order_number: "",
      other: "",
      page_title: "",
      request_return: "",
      return_app_processed_item: "",
      search_order_button: "",
      view_button: "",
      view_request_progress: "",
    },
    return_item_selection_page: {
      cancel: "",
      confirm: "",
      edit: "",
      next: "",
      one_item_prompt: "",
      optional: "",
      please_select: "",
      popup_title: "",
      prompt: "",
      provide_proof: "",
      required: "",
      return_description: "",
      return_quantity: "",
      return_reason: "",
      step_1: "",
      step_2: "",
      step_3: "",
      step_4: "",
      title: "",
    },
    return_method_selection_page: {
      List: [],
      title: "",
    },
    return_solution_selection_page: {
      List: [],
      replace_title: "",
      replacement: "",
      select_replacement: "",
      title: "",
    },
    return_status_page: {
      actual_refund: "",
      add: "",
      add_tracking: "",
      approved_status: "",
      complete_return_status: "",
      customer_address: "",
      create_success_status: "",
      discount_code: "",
      download_return_label: "",
      enter_shipment_details: "",
      exchange_order: "",
      exchange_order_created: "",
      gift_card_code: "",
      merchant_contact: "",
      order_info: "",
      pending_status: "",
      received_status: "",
      refund_pending: "",
      refunded: "",
      refunded_status: "",
      reject_reason: "",
      rejected_status: "",
      resolved_status: "",
      return_address: "",
      return_details: "",
      return_method: "",
      return_solution: "",
      search_carrier: "",
      shipping_carrier: "",
      shop_now: "",
      tracking_number: "",
      wait_for_review: "",
    },
  }

  // 页面Loading状态
  @observable public loading = false

  // 保存按钮Loading状态
  @observable public saveLoading = false

  // 保存按钮活跃状态
  @observable public saveBtnActive = false

  @observable public languageList: langInfo[] = []

  @observable public displayLang: langInfo[] = []

  // 选中的页面
  @observable public activeLanguageModule: LanguageModule =
    LanguageModule.LOGIN_PAGE

  // email整体配置
  @observable public config: any = {
    defaultLabel: "English (default)",
    translateLabel: "chinese",
    default: {
      policy_popup_name: "Returns and Exchanges Policy FAQ",
      order_number: "Order Number1",
      verification_code: "Verification code",
      confirm_button_name: "Start Your Return",
      bottom_description:
        "You have a maximum of 30 days from the date of your purchase to make a return.",
      error_tips_1: "1",
      error_tips_2: "1",
      error_tips_3: "Please enter a valid order number and email address",
      policy_text: "View the full return policy1",
      email_address: "Email address1",
      order_email_address: "Email Address",
      order_confirm_button_name: "Start Your Return1",
      order_bottom_description:
        "You have a maximum of 30 days from the date of your purchase to make a return.1",
      return_center: "Return Center12",
    },
    translate: {
      policy_popup_name: "返品と交換ポリシーFAQ",
      order_number: "注文番号",
      verification_code: "認証コード",
      confirm_button_name: "返品を開始",
      bottom_description: "返品するには、購入日から最大30日間が必要です。",
      error_tips_1: "有効なメールアドレスを入力してください",
      error_tips_2: "有効な認証コードを入力してください",
      error_tips_3: "有効な注文番号とメールアドレスを入力してください",
      policy_text: "全ての返品ポリシーを見る",
      email_address: "メールアドレス",
      order_email_address: "メールアドレス",
      order_confirm_button_name: "返品を開始",
      order_bottom_description:
        "返品するには、購入日から最大30日間が必要です。",
      return_center: "返品センター",
    },
  }

  constructor() {
    makeObservable(this)
  }

  /**
   * 设置原字段
   */
  @action.bound
  public setOriginData(data) {
    this.originData = data
  }

  /**
   * 设置配置
   */
  @action.bound
  public setConfig(config: any): void {
    this.config = config
  }

  /**
   * 还原数据
   */
  @action.bound
  public resetData(data) {
    const _data = cloneDeep(data)

    this.config.translate = _data
  }

  /**
   * 设置目标配置，局部
   */
  @action.bound
  public setTargetConfig<T>(path: string, v: T) {
    set(this.config, path, v)
  }
  /**
   * 设置目标配置，局部
   */
  @action.bound
  public setTargetConfigValue<T>(
    module: string,
    index: number,
    subIndex: number,
    val: string,
  ) {
    set(this.config, `${module}[${index}][${subIndex}].value`, val)
  }
  /**
   * 设置语言列表
   */
  @action.bound
  public setLanguageList(list: langInfo[]) {
    const _list = list.sort((a, b) => b.is_default - a.is_default)

    this.languageList = _list
  }

  /**
   * 设置翻译页面的语言列表
   */
  @action.bound
  public setDisplayLang(list: langInfo[]) {
    this.displayLang = list
  }

  /**
   * 切换当前保存激活状态
   */
  @action.bound
  public setSaveBtnActive(type: boolean): void {
    this.saveBtnActive = type
  }
  /**
   * 切换当前Loading状态
   */
  @action.bound
  public setLoading(type: boolean): void {
    this.loading = type
  }
  /**
   * 切换保存Loading状态
   */
  @action.bound
  public setSaveLoading(type: boolean): void {
    this.saveLoading = type
  }
  /**
   * 设置选中的页面
   */
  @action.bound
  public setModuleActive(module: LanguageModule) {
    this.activeLanguageModule = module
  }
}

export default LanguageStore
